<template>
  <h2 class="error">{{ errorMessage }}</h2>
</template>

<script>
export default {
  name: "Error",
  props: ["errorMessage"],
};
</script>
